import { useUser } from '@clerk/clerk-react';
import { useLocation } from 'react-router-dom';

// Using test mode payment link
const PAYMENT_LINK = 'https://buy.stripe.com/test_8wMaGV44o3Zy8ow288';

export const useStripeCheckout = () => {
  const { user } = useUser();
  const location = useLocation();

  const redirectToCheckout = async () => {
    try {
      if (!user?.id || !user?.primaryEmailAddress?.emailAddress) {
        throw new Error('User information is missing');
      }

      // Add URL parameters to track success and cancel redirects
      const successUrl = encodeURIComponent(`${window.location.origin}/success`);
      const cancelUrl = encodeURIComponent(`${window.location.origin}/cancel?returnPath=${location.pathname}`);
      
      // Construct the payment URL with all necessary parameters
      const paymentUrl = new URL(PAYMENT_LINK);
      paymentUrl.searchParams.append('client_reference_id', user.id);
      paymentUrl.searchParams.append('prefilled_email', user.primaryEmailAddress.emailAddress);
      paymentUrl.searchParams.append('success_url', successUrl);
      paymentUrl.searchParams.append('cancel_url', cancelUrl);

      // Redirect to the payment link
      window.location.href = paymentUrl.toString();
    } catch (error) {
      console.error('Error redirecting to checkout:', error);
      throw error;
    }
  };

  return { redirectToCheckout };
};
